<h2 i18n>Paying by Credit/Debit card - Additional verification</h2>
<p i18n>
    Your card payment is being processed and requires additional verification.
</p>
<p i18n>
    Please wait while we verify the payment.
</p>
